<template>
  <div>
    <div class="InputCom">
      <!-- <div class="tit">{{$t('DataHub.Services')}}</div> -->
      <div class="search_input">
        <div class="search_input_box">
          <input
            type="text"
            v-model="searchVal"
            :placeholder="$t('DataHub.Key')"
            @keyup.13="searchFun()"
            v-log="{ params: { clickName: '搜索数据' } }"
          />
          <div class="search_doc">
            <div class="txt">
              <div v-if="loading" class="loading_txt">
                <div class="dot-loader"></div>
                <div class="dot-loader"></div>
                <div class="dot-loader"></div>
              </div>
              <div
                v-else
                v-log="{ params: { clickName: '搜索数据' } }"
                @click="searchFun()"
                class="search_btn"
              >
                <!-- {{$t('DataHub.Search')}} -->
                <i class="iconfont icon-chaxun4"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="hot_search" v-if="terminal == 'pc'">
          <div class="hot_search_tit">{{$t('DataSerch.key')}}:</div>
          <ul class="hot_search_ul">
            <li
              @click="searchText('Himawari')"
              v-log="{ params: { clickName: '搜索数据' } }"
            >
              Himawari<i class="iconfont icon-daochu1024-07"></i>
            </li>
            <li
              @click="searchText('Landsat')"
              v-log="{ params: { clickName: '搜索数据' } }"
            >
              Landsat
            </li>
            <li
              @click="searchText('Sentinel')"
              v-log="{ params: { clickName: '搜索数据' } }"
            >
              
                <div v-if="language == 'fran'">Sentinelle</div>
               <div v-else >Sentinel</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  name: "Input",
  data() {
    return {
      loading: false,
      searchVal: "",
    };
  },
  beforeDestroy() {
    this.$bus.$off("SearchAccomplish");
  },
  mounted() {
    bus.$on("SearchAccomplish", () => {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    });
  },
  methods: {
    searchFun() {
      if (this.loading) {
        return;
      }
      // this.loading = true;
      // bus.$emit("SearchDataList", this.searchVal);
      this.$router.push(`/dataSearch?searchKey=${this.searchVal}`);
    },
    searchText(val) {
      this.searchVal = val;
      this.$router.push(`/dataSearch?searchKey=${this.searchVal}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .InputCom {
    display: flex;
    flex-direction: row;
    width: 800px;
    margin: auto;
    flex-wrap: nowrap;
    .tit {
      margin-right: 10px;
      color: #fff;
      font-weight: 600;
      padding-top: 11px;
    }
    .search_input {
      display: flex;
      flex-direction: column;
      flex: 1;
      .search_input_box {
        //   margin-right: 10px;
        position: relative;

        input {
          width: 100%;
          height: 50px;
          border-radius: 2px;
          text-indent: 10px;
          color: #333;

          font-size: 14px;
          border: 1px solid rgba(0, 86, 206, 1);
        }
        input::-webkit-input-placeholder {
          color: #999;
          font-size: 14px;
          padding-left: 6px;
        }
        .search_doc {
          height: 100%;
          width: 100px;
          position: absolute;
          right: 0px;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
          background: rgba(255, 149, 44, 1);
          top: 0px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .search_loading {
            color: #999;
            font-size: 12px;
            margin-right: 20px;
          }

          .txt {
            width: 100%;
            cursor: pointer;
            color: rgba(56, 75, 255, 1);
            font-weight: 600;
            font-size: 16px;
            transition: 0.2s;
            display: flex;
            flex-direction: row;
            justify-content: center;
            .search_btn {
              width: 100px;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              i {
                color: #fff;
                font-size: 20px;
              }
            }
            .search_t_ {
              margin-right: 10px;
            }
            .loading_txt {
              color: #ccc;
              display: flex;
              flex-direction: row;
              align-items: center;
              // .nb-spinner {

              //   width: 28px;
              //   height: 28px;
              //   margin: 0;
              //   background: transparent;
              //   border-top: 4px solid #009688;
              //   border-right: 4px solid transparent;
              //   border-radius: 50%;
              //   -webkit-animation: 1s spin linear infinite;
              //   animation: 1s spin linear infinite;
              // }
            }
            &:hover {
              transition: 0.2s;
              opacity: 0.5;
            }
          }
        }
      }
      .hot_search {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        align-items: center;
        .hot_search_tit {
          color: #fff;
          font-size: 14px;
          margin-right: 10px;
        }
        .hot_search_ul {
          display: flex;
          flex-direction: row;
          align-items: center;
          li {
            color: #fff;
            padding: 0px 10px;
            font-size: 14px;
            margin-right: 10px;
            border-radius: 20px;
            i {
              font-size: 18px;
              color: rgba(255, 149, 44, 1);
              margin-left: 2px;
            }
          }
        }
      }
    }
  }
  .dot-loader {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: #fff;
    position: relative;
    -webkit-animation: 1.2s scaleDown ease-in-out infinite;
    animation: 1.2s scaleDown ease-in-out infinite;
  }

  .dot-loader:nth-child(2) {
    margin: 0 6px;
    -webkit-animation: 1.2s scaleDown ease-in-out infinite 0.15555s;
    animation: 1.2s scaleDown ease-in-out infinite 0.15555s;
  }

  .dot-loader:nth-child(3) {
    -webkit-animation: 1.2s scaleDown ease-in-out infinite 0.3s;
    animation: 1.2s scaleDown ease-in-out infinite 0.3s;
  }

  @-webkit-keyframes scaleDown {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes scaleDown {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .InputCom {
    display: flex;
    flex-direction: row;
    width: 800px;
    margin: auto;
    // align-items: center;
    .tit {
      width: 80px;
      color: #fff;
      font-weight: 600;
      padding-top: 6px;
    }
    .search_input {
      display: flex;
      flex-direction: column;
      flex: 1;
      .search_input_box {
        //   margin-right: 10px;
        position: relative;
        input {
          width: 100%;
          height: 42px;
          border-radius: 10px;
          text-indent: 10px;
          color: #333;
          font-size: 13px;
          border: 1px solid rgba(0, 86, 206, 1);
        }
        input::-webkit-input-placeholder {
          color: #999;
          font-size: 13px;
          padding-left: 6px;
        }
        .search_doc {
          height: 42px;
          position: absolute;
          right: 10px;
          top: 0px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .search_loading {
            color: #999;
            font-size: 12px;
            margin-right: 20px;
          }
          .hr {
            color: #ccc;
          }
          .txt {
            cursor: pointer;
            color: rgba(56, 75, 255, 1);
            font-weight: 600;
            font-size: 14px;
            margin-left: 4px;
            transition: 0.2s;
            .search_t_ {
              margin-right: 10px;
            }
            .loading_txt {
              width: 100px;
              color: #ccc;
              display: flex;
              flex-direction: row;
              align-items: center;
              // .nb-spinner {

              //   width: 28px;
              //   height: 28px;
              //   margin: 0;
              //   background: transparent;
              //   border-top: 4px solid #009688;
              //   border-right: 4px solid transparent;
              //   border-radius: 50%;
              //   -webkit-animation: 1s spin linear infinite;
              //   animation: 1s spin linear infinite;
              // }
            }
            &:hover {
              transition: 0.2s;
              opacity: 0.5;
            }
          }
        }
      }
      .hot_search {
        display: flex;
        flex-direction: row;
        margin-top: 6px;
        align-items: center;
        .hot_search_tit {
          color: #fff;
          font-size: 14px;
          margin-right: 10px;
        }
        .hot_search_ul {
          display: flex;
          flex-direction: row;
          align-items: center;
          li {
            color: #fff;
            padding: 2px 10px;
            font-size: 14px;
            background: rgba(22, 74, 108, 1);
            margin-right: 10px;
            border-radius: 20px;
          }
        }
      }
    }
  }
  .dot-loader {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: #03a9f4;
    position: relative;
    -webkit-animation: 1.2s scaleDown ease-in-out infinite;
    animation: 1.2s scaleDown ease-in-out infinite;
  }

  .dot-loader:nth-child(2) {
    margin: 0 6px;
    -webkit-animation: 1.2s scaleDown ease-in-out infinite 0.15555s;
    animation: 1.2s scaleDown ease-in-out infinite 0.15555s;
  }

  .dot-loader:nth-child(3) {
    -webkit-animation: 1.2s scaleDown ease-in-out infinite 0.3s;
    animation: 1.2s scaleDown ease-in-out infinite 0.3s;
  }

  @-webkit-keyframes scaleDown {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes scaleDown {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
}
@media screen and (max-width: 767px) {
  .InputCom {
    display: flex;
    flex-direction: row;
    // width: 100%;
    padding: 0 20px;
    margin: auto;
    // align-items: center;
    .tit {
      // width: 80px;
      margin-top: 4px;
      margin-right: 8px;
      color: #fff;
      font-weight: 600;
      padding-top: 6px;
    }
    .search_input {
      display: flex;
      flex-direction: column;
      flex: 1;
      .search_input_box {
        //   margin-right: 10px;
        position: relative;
        input {
          width: 100%;
          height: 42px;
          border-radius: 10px;
          text-indent: 10px;
          color: #333;
          font-size: 13px;
          border: 1px solid rgba(0, 86, 206, 1);
        }
        input::-webkit-input-placeholder {
          color: #999;
          font-size: 13px;
          padding-left: 6px;
        }
        .search_doc {
          height: 42px;
          position: absolute;
          right: 10px;
          top: 0px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .search_loading {
            color: #999;
            font-size: 12px;
            margin-right: 20px;
          }
          .hr {
            color: #ccc;
          }
          .txt {
            cursor: pointer;
            color: rgba(56, 75, 255, 1);
            font-weight: 600;
            font-size: 14px;
            margin-left: 4px;
            transition: 0.2s;
            .search_t_ {
              margin-right: 10px;
            }
            .loading_txt {
              color: #ccc;
              display: flex;
              flex-direction: row;
              align-items: center;
              // .nb-spinner {

              //   width: 28px;
              //   height: 28px;
              //   margin: 0;
              //   background: transparent;
              //   border-top: 4px solid #009688;
              //   border-right: 4px solid transparent;
              //   border-radius: 50%;
              //   -webkit-animation: 1s spin linear infinite;
              //   animation: 1s spin linear infinite;
              // }
            }
            &:hover {
              transition: 0.2s;
              opacity: 0.5;
            }
          }
        }
      }
      .hot_search {
        display: flex;
        flex-direction: row;
        margin-top: 6px;
        align-items: center;
        .hot_search_tit {
          width: 110px;
          color: #fff;
          font-size: 14px;
          margin-right: 10px;
        }
        .hot_search_ul {
          display: flex;
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;
          li {
            color: #fff;
            padding: 2px 10px;
            font-size: 14px;
            background: rgba(22, 74, 108, 1);
            margin: 2px 10px;
            border-radius: 20px;
          }
        }
      }
    }
  }
  .dot-loader {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: #03a9f4;
    position: relative;
    -webkit-animation: 1.2s scaleDown ease-in-out infinite;
    animation: 1.2s scaleDown ease-in-out infinite;
  }

  .dot-loader:nth-child(2) {
    margin: 0 6px;
    -webkit-animation: 1.2s scaleDown ease-in-out infinite 0.15555s;
    animation: 1.2s scaleDown ease-in-out infinite 0.15555s;
  }

  .dot-loader:nth-child(3) {
    -webkit-animation: 1.2s scaleDown ease-in-out infinite 0.3s;
    animation: 1.2s scaleDown ease-in-out infinite 0.3s;
  }

  @-webkit-keyframes scaleDown {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes scaleDown {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
}
</style>